import { render, staticRenderFns } from "./PaymentDetailsWidget.vue?vue&type=template&id=63b66631"
import script from "./PaymentDetailsWidget.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports